/**
 * @class Oskari.userinterface.component.TextInput
 *
 * Simple text input component
 */
Oskari.clazz.define('Oskari.userinterface.component.TextInput',
/**
 * @method create called automatically on construction
 */
function (name) {
  var me = this,
    closeIcon = document.createElement('div'),
    controlsWrapper = document.createElement('div');
  me._clazz = 'Oskari.userinterface.component.TextInput';
  me._element = document.createElement('label');
  me._titleEl = document.createElement('div');
  me._input = document.createElement('input');
  me._element.className = 'oskari-formcomponent oskari-textinput';
  me._titleEl.style.display = 'none';
  if (name !== null && name !== undefined) {
    me.setName(name);
  }
  me._input.type = 'text';
  me._input.setAttribute('autocomplete', 'off');
  // TODO none of these fire on autofill, it would need a timer...
  me._input.onchange = function () {
    me._valueChanged();
  };
  me._input.input = me._input.onchange;
  me._input.onkeyup = me._input.onchange;
  closeIcon.onclick = function () {
    me.setValue('');
  };
  closeIcon.className = 'icon-close';
  controlsWrapper.className = 'input-controls';
  controlsWrapper.appendChild(me._input);
  controlsWrapper.appendChild(closeIcon);
  me._element.appendChild(me._titleEl);
  me._element.appendChild(controlsWrapper);
}, {
  /**
   * @method focus
   * Focuses the component.
   */
  focus: function focus() {
    this._input.focus();
  },
  /**
   * @method isEnabled
   * @return {Boolean} enabled
   */
  isEnabled: function isEnabled() {
    return !this.getElement().disabled;
  },
  /**
   * @method _setEnabledImpl
   * @param {Boolean} enabled
   */
  _setEnabledImpl: function _setEnabledImpl(enabled) {
    this._input.disabled = !enabled;
  },
  /**
   * @method _valueChanged
   * @private
   */
  _valueChanged: function _valueChanged() {
    if (this.getHandler()) {
      this.getHandler()(this.getValue());
    }
  },
  /**
   * @method getName
   * @return {String} name
   */
  getName: function getName() {
    return this._input.name;
  },
  /**
   * @method setName
   * @param {String} name
   */
  setName: function setName(name) {
    this._input.name = name || '';
  },
  /**
   * @method getPlaceholder
   * @return {String} placeholder
   */
  getPlaceholder: function getPlaceholder() {
    return this._input.placeholder;
  },
  /**
   * @method setPlaceholder
   * @param {String} placeholder
   */
  setPlaceholder: function setPlaceholder(placeholder) {
    this._input.placeholder = placeholder;
  },
  /**
   * @method _setRequiredImpl
   */
  _setRequiredImpl: function _setRequiredImpl() {
    this._input.required = this.isRequired();
  },
  /**
   * @method getTitle
   * @return {String} title
   */
  getTitle: function getTitle() {
    return this._titleEl.textContent;
  },
  /**
   * @method setTitle
   * @param {String} title
   */
  setTitle: function setTitle(title) {
    this._titleEl.textContent = '';
    if (title !== null && title !== undefined) {
      this._titleEl.style.display = '';
      this._titleEl.appendChild(document.createTextNode(title));
    } else {
      this._titleEl.style.display = 'none';
    }
  },
  /**
   * @method getTooltip
   * @return {String} tooltip
   */
  getTooltip: function getTooltip() {
    return this._element.title;
  },
  /**
   * @method setTooltip
   * @param {String} tooltip
   */
  setTooltip: function setTooltip(tooltip) {
    this._element.title = tooltip;
  },
  /**
   * @method getValue
   * @return {String} value
   */
  getValue: function getValue() {
    return this._input.value;
  },
  /**
   * @method setValue
   * @param {String} value
   */
  setValue: function setValue(value) {
    this._input.value = value;
  },
  /**
   * @method _setVisibleImpl
   */
  _setVisibleImpl: function _setVisibleImpl() {
    this.getElement().style.display = this.isVisible() ? '' : 'none';
  }
}, {
  extend: ['Oskari.userinterface.component.FormComponent']
});